import { defHttp } from '/@/request';
import { ErrorMessageMode, Result } from '/#/axios';
import type { AxiosResponse } from 'axios';

import {
  ServiceSheetPageParamsModel,
  ServiceSheetPageResultModel,
  ServiceSheetVideoParamsModel,
  ServiceSheetVideoResultModel,
  ErrorDescListResultModel,
  SheetModal,
  CompleteSheetParamsModel,
  GoodsImageParamsModel,
  ServiceSheetResultResultModel,
  ServiceSheetGoodsDisplayResultModel,
  SheetCameraFaultReportParamsModel,
  DictListhResultModel,
  DicthParamsModel,
  LinkGoodsInfoResultModel,
  VideoIdModal,
  VideoRecordMachineResultModel,
} from './model/serviceModel';

import { getAppEnvConfig } from '/@/utils/env';
const { VITE_GLOB_REPAIR_FILE_URL } = getAppEnvConfig();

enum Api {
  ServiceSheet = 'worksheet/info/v1/list/page', // 工单列表
  ServiceSheetDetail = 'worksheet/info/v1/list/video', // 获取工单视频列表
  DelayTime = 'worksheet/info/v1/delay', // 延长工单5分钟
  ServiceSheetHang = 'worksheet/info/v3/pull', // 挂起工单
  ServiceSheetComplete = 'worksheet/info/v3/finish', // 完成工单
  PreviewCircleGoodsImage = 'worksheet/info/v1/goods/pic', // 查看商品环拍图
  AssistVideoList = 'worksheet/info/v1/assist/video', // 捞取辅视频
  SheetResult = 'worksheet/info/v1/handle/result', // 获取工单处理结果

  SheetGoodsDisplay = 'goods/video/record/v1/machine', // 获取机器商品陈列

  SheetFaultReport = 'worksheet/info/v1/report/monitor', // 故障上报
  dictList = 'base/dict/v1/list', // 字典查询

  // 识别详情
  videoDetailList = 'goods/video/record/v1/detail', // 获取视频列表
  videoGoodsTags = 'goods/resource/tag/v1/list', // 获取异常藐视tag
  displayCheckGoods = 'goods/video/check/v1/display',
  videoReordResult = 'goods/video/record/v1/result', // 视频详情查询识别结果详情
  videoRecordPicture = 'goods/video/record/v1/picture', // 查询机器商品图片
  // resultCheck = 'goods/video/check/v1/recognition/result',
  falseWorkDetail = 'goods/video/check/v1/recognition/result',
  resultCheck = 'goods/video/train/detail/v1/recognition/result',
  videoCheckResult = 'goods/video/check/v1/check',
  submitTrainDetail = 'goods/video/train/detail/v1/submit',

  // 错误工单
  falseWorkSheet = 'goods/video/check/v1/error/page',
  exportFalseWorkSheet = 'goods/video/check/v1/error/export',
  // 关联商品
  linkGoodsInfo = 'goods/tenant/v1/library/link',
  // 捞取主视频
  TakeOutMainVideo = '',
  videoRecordMachine = 'goods/video/record/v1/machine', // 获取机器商品陈列
  videoTest = 'goods/video/v1/test',
  allWorkSheet = 'worksheet/info/v1/all/page', // 获取全部工单？？
  exportAllWorkSheet = '', //导出全部工单
  sheetTodayInfo = 'data/sheet/v1/today/info', //查询今日完成和今日错误
  startWork = 'worksheet/rule/v1/start/work',
  stopWork = 'worksheet/rule/v1/stop/work',
  stopWorkNum = 'worksheet/rule/v1/stop/num',
  pollingWorksheet = 'worksheet/info/v1/polling',
}
// 工单列表
export function getServiceSheetPageApi(data: ServiceSheetPageParamsModel, mode?: ErrorMessageMode) {
  return defHttp.post<Result<ServiceSheetPageResultModel>>(
    {
      url: Api.ServiceSheet,
      data,
    },
    { errorMessageMode: mode || 'message' },
  );
}
// 获取工单视频列表
export function getServiceSheetVideoApi(data: ServiceSheetVideoParamsModel, mode?: ErrorMessageMode) {
  return defHttp.post<Result<ServiceSheetVideoResultModel>>(
    {
      url: Api.ServiceSheetDetail,
      data,
    },
    { errorMessageMode: mode || 'message' },
  );
}

// 延长工单5分钟
export function sheetDelayTimeApi(data: SheetModal, mode?: ErrorMessageMode) {
  return defHttp.post<Result<null>>(
    {
      url: Api.DelayTime,
      data,
    },
    { errorMessageMode: mode || 'message' },
  );
}
// 挂起工单
export function sheetHangApi(data: SheetModal, mode?: ErrorMessageMode) {
  return defHttp.post<Result<string>>(
    {
      url: Api.ServiceSheetHang,
      data,
    },
    { errorMessageMode: mode || 'message' },
  );
}
// 完成工单
export function sheetCompleteApi(data: CompleteSheetParamsModel, mode?: ErrorMessageMode) {
  return defHttp.post<Result<string>>(
    {
      url: Api.ServiceSheetComplete,
      data,
    },
    { errorMessageMode: mode || 'message' },
  );
}
// 查看商品环拍图
export function previewGoodsImageApi(data: GoodsImageParamsModel, mode?: ErrorMessageMode) {
  return defHttp.post<Result<string[]>>(
    {
      url: Api.PreviewCircleGoodsImage,
      data,
    },
    { errorMessageMode: mode || 'message' },
  );
}
// 捞取视频列表
export function getServiceAssistVideoListApi(data: ServiceSheetVideoParamsModel, mode?: ErrorMessageMode) {
  return defHttp.post<Result<null>>(
    {
      url: Api.AssistVideoList,
      data,
    },
    { errorMessageMode: mode || 'message' },
  );
}
// export function takeOutMainVideoApi(data) {
//   return defHttp.post<Result<null>>({
//     url: Api.TakeOutMainVideo,
//     data,
//   });
// }
// 获取工单处理结果
export function getServiceSheetResultApi(data: SheetModal, mode?: ErrorMessageMode) {
  return defHttp.post<Result<ServiceSheetResultResultModel>>(
    {
      url: Api.SheetResult,
      data,
    },
    { errorMessageMode: mode || 'message' },
  );
}
// 获取机器商品陈列
export function getServiceSheetGoodsDisplayApi(data: SheetModal, mode?: ErrorMessageMode) {
  return defHttp.post<Result<ServiceSheetGoodsDisplayResultModel>>(
    {
      url: Api.SheetGoodsDisplay,
      data,
    },
    { errorMessageMode: mode || 'message' },
  );
}
// 故障上报
export function sheetCameraFaultReportApi(data: SheetCameraFaultReportParamsModel, mode?: ErrorMessageMode) {
  return defHttp.post<Result<null>>(
    {
      url: Api.SheetFaultReport,
      data,
    },
    { errorMessageMode: mode || 'message' },
  );
}
// 修复视频
export function repairVideoApi(data: { videoName: string; model?: string }) {
  return defHttp.post<Result<any>>({
    url: VITE_GLOB_REPAIR_FILE_URL,
    data,
  });
}

export function dictListApi(data: DicthParamsModel) {
  return defHttp.post<Result<DictListhResultModel>>({
    url: Api.dictList,
    data,
  });
}

// 详情获取视频列表
export function videoDetailListApi(data: any) {
  return defHttp.post<Result<any>>({
    url: Api.videoDetailList,
    data,
  });
}

//获取商品
export function displayCheckGoodsApi(data: any, mode?: ErrorMessageMode) {
  return defHttp.post<Result<any>>(
    {
      url: Api.displayCheckGoods,
      data,
    },
    { errorMessageMode: mode || 'message' },
  );
}
// 识别结果详情
export function videoReordResultApi(data: any) {
  return defHttp.post<Result<any>>({
    url: Api.videoReordResult,
    data,
  });
}

// 查看商品环拍图
export function videoRecordPictureApi(data: GoodsImageParamsModel) {
  return defHttp.post<Result<string[]>>({
    url: Api.videoRecordPicture,
    data,
  });
}

//查询抽检任务的识别结果
export function resultCheckApi(data: any) {
  return defHttp.post<Result<any>>({
    url: Api.resultCheck,
    data,
  });
}

//完成抽检前，判断抽检结果
export function videoCheckResultApi(data: any, mode?: ErrorMessageMode) {
  return defHttp.post<Result<any>>(
    {
      url: Api.videoCheckResult,
      data,
    },
    { errorMessageMode: mode || 'message' },
  );
}

export function submitTrainDetailApi(data: any, mode?: ErrorMessageMode) {
  return defHttp.post<Result<any>>(
    {
      url: Api.submitTrainDetail,
      data,
    },
    { errorMessageMode: mode || 'message' },
  );
}

export const falseWorkSheetApi = (data: any, mode?: ErrorMessageMode) => {
  return defHttp.post<Result<any>>({ url: Api.falseWorkSheet, data }, { errorMessageMode: mode || 'message' });
};

export const exportFalseWorkSheetApi = (data: any, mode?: ErrorMessageMode) => {
  return defHttp.post<AxiosResponse<Blob>>(
    {
      url: Api.exportFalseWorkSheet,
      data,
      responseType: 'blob',
    },
    { errorMessageMode: mode || 'message', isReturnNativeResponse: true },
  );
};

export function falseWorkDetailApi(data: any) {
  return defHttp.post<Result<any>>({
    url: Api.falseWorkDetail,
    data,
  });
}

//获取关联商品
export function getLinkGoodsInfo(data: GoodsImageParamsModel, mode?: ErrorMessageMode) {
  return defHttp.post<Result<LinkGoodsInfoResultModel>>(
    {
      url: Api.linkGoodsInfo,
      data,
    },
    { errorMessageMode: mode || 'message' },
  );
}

// 获取机器商品陈列
export function videoRecordMachineApi(data: VideoIdModal, mode?: ErrorMessageMode) {
  return defHttp.post<Result<VideoRecordMachineResultModel>>(
    {
      url: Api.videoRecordMachine,
      data,
    },
    { errorMessageMode: mode || 'message' },
  );
}
// 获取异常描述的tag
export function videoGoodsTagsApi() {
  return defHttp.post<Result<ErrorDescListResultModel>>({
    url: Api.videoGoodsTags,
  });
}
//修改抽检结果
export function videoTestApi(data: { tradeNo: string }, mode?: ErrorMessageMode) {
  return defHttp.post<Result<any>>(
    {
      url: Api.videoTest,
      data,
    },
    { errorMessageMode: mode || 'message' },
  );
}
export const allWorkSheetApi = (data: any, mode?: ErrorMessageMode) => {
  return defHttp.post<Result<any>>({ url: Api.allWorkSheet, data }, { errorMessageMode: mode || 'message' });
};

export const exportAllWorkSheetApi = (data: any, mode?: ErrorMessageMode) => {
  return defHttp.post<AxiosResponse<Blob>>(
    {
      url: Api.exportAllWorkSheet,
      data,
      responseType: 'blob',
    },
    { errorMessageMode: mode || 'message', isReturnNativeResponse: true },
  );
};

export const sheetTodayInfoApi = (data?: any) => {
  return defHttp.post<Result<any>>({
    url: Api.sheetTodayInfo,
    data,
  });
};

export function startWorkApi() {
  return defHttp.post<Result<any>>({
    url: Api.startWork,
  });
}
export function stopWorkApi() {
  return defHttp.post<Result<any>>({
    url: Api.stopWork,
  });
}
export function stopWorkNumApi() {
  return defHttp.post<Result<any>>({
    url: Api.stopWorkNum,
  });
}
export function pollingWorksheetApi() {
  return defHttp.post<Result<any>>({
    url: Api.pollingWorksheet,
  });
}
